var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutomaticallyPlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/forward-15-seconds"
  }, /*#__PURE__*/React.createElement("g", {
    id: "forward-15-seconds"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.37 5.03046L13.9336 2.20947",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.6955 9.32987C20.4814 11.0047 20.7849 12.9367 20.3782 14.8949C19.3797 19.7024 14.6736 22.7899 9.86615 21.7915C5.05873 20.7931 1.97119 16.0869 2.96961 11.2795C3.96803 6.47206 8.67421 3.38451 13.4816 4.38293C14.1474 4.52121 14.7753 4.74358 15.3714 5.02059",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.98047 13.3258V11.9358C8.98047 10.2158 10.2005 9.50575 11.6905 10.3658L12.8905 11.0558L14.0905 11.7458C15.5805 12.6058 15.5805 14.0158 14.0905 14.8758L12.8905 15.5658L11.6905 16.2558C10.2005 17.1158 8.98047 16.4158 8.98047 14.6858V13.3258Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomaticallyPlay);
export default __webpack_public_path__ + "static/media/automatically-play.246b7785bffbed60d6cd3c6cf82e6c5b.svg";
export { ForwardRef as ReactComponent };